module.exports = {"210782004":"北镇街道","210782005":"观音阁街道","210782006":"富屯街道","210782007":"广宁街道","210782008":"沟帮子街道","210782009":"沙子河街道","210782101":"大市镇","210782102":"罗罗堡镇","210782103":"常兴店镇","210782104":"正安镇","210782105":"闾阳镇","210782106":"中安镇","210782107":"廖屯镇","210782109":"赵屯镇","210782110":"青堆子镇","210782111":"高山子镇","210782113":"吴家镇","210782203":"鲍家乡","210782206":"大屯乡","210782209":"柳家乡","210782402":"辽宁省北镇市高山子监狱","210782403":"新立农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210782.json
// module id = 509
// module chunks = 0